import React, { Fragment, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Card, CardBody, Row, Input, Button } from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import {
  gAPI_Visitors_Conversations_list,
  API_Ingetration_Channels,
  aPI_Contacts,
} from '../../../../../constants/APIs';
import classnames from 'classnames';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import ContactDetails from './contactDetails';
import moment from 'moment';
import { connect } from 'react-redux';
import ContactForm from './contactForm';

function ContactInfo({ propertyId, chatListApp, match, item }) {
  const contactId = match.params.id;
  const [editContact, setEditContact] = useState(false);
  const [note, setNote] = useState('');
  const [contact, setContact] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedChat, setSelectedChat] = useState();
  const [integrations, setIntegrations] = useState([]);
  useEffect(
    (propertyId) => {
      const callApi = async () => {
        if (contactId !== undefined && contactId !== '') {
          await handleContactLoad();
        }
        await LoadIntegrations();
      };
      callApi();
    },
    [propertyId]
  );
  useEffect(
    (props) => {
      if (selectedChat?.conversationId) {
        if (
          selectedChat?.conversationId !==
          chatListApp?.selectedchat?.conversationId
        ) {
          setSelectedChat(chatListApp?.selectedchat);
        }
      } else setSelectedChat(chatListApp?.selectedchat);
    },
    [chatListApp]
  );
  const handleContactLoad = async () => {
    const contactResponse = await AxiosAPI({
      method: 'get',
      url: `${aPI_Contacts}/${contactId}`,
    });
    if (contactResponse.data !== undefined && contactResponse.data?.contactId)
      setContact(contactResponse.data);
  };

  const LoadIntegrations = async () => {
    setIsLoading(true);
    let body = {
      channels: ['WebsiteDirectLine', 'FacebookDirectLine', 'WhatsApp'],
    };
    const response = await AxiosAPI({
      method: 'post',
      url: `${API_Ingetration_Channels}?group_id=${getGroupID()}`,
      data: body,
    });
    if (response.data.length > 0) {
      const webIntegrationData = response.data.filter(
        (k) =>
          (k.channel === 'WebsiteDirectLine' ||
            k.channel === 'FacebookDirectLine' ||
            k.channel === 'WhatsApp') &&
          k.properties.filter((f) => f == propertyId).length > 0
      );
      setIntegrations(webIntegrationData);
    } else {
    }
  };

  const toggle = () => setEditContact(!editContact);

  const handleEdit = (body) => {
    AxiosAPI({
      method: 'put',
      url: `${aPI_Contacts}/${contactId}`,
      data: body,
    }).then((res) => {
      toggle();
      handleContactLoad();
    });
  };

  const handleSaveNotes = () => {
    if (note !== '') {
      AxiosAPI({
        method: 'put',
        url: `${aPI_Contacts}/notes/${contactId}`,
        data: { note: note },
      }).then((res) => {
        setNote();
        handleContactLoad();
      });
    }
  };

  return (
    <Fragment>
      {contact !== undefined && (
        <Row style={{ marginLeft: '-3%', marginRight: '-2%' }}>
          <Colxx xxs="12" md="3" className="mb-2 col-sm-12 col-md-3 pr-0">
            <Card
              className="d-flex flex-row mb-2"
              style={{ borderRadius: '10px' }}
            >
              <CardBody>
                <div className="mb-3">
                  <Colxx md="12" className="mb-2">
                    <div class="user-info">
                      <div className="d-flex justify-content-center">
                        <div className="contact-round-name">
                          <span>
                            <b>
                              {contact?.name ? (
                                <Fragment>
                                  {contact.name.split(' ').length > 1
                                    ? contact.name.split(' ')[0][0] +
                                      contact.name.split(' ')[1][0]
                                    : contact.name[0] + contact.name[1]}
                                </Fragment>
                              ) : (
                                'UK'
                              )}
                            </b>
                          </span>
                          <span
                            className="contact-details-edit"
                            onClick={toggle}
                          >
                            <i className="simple-icon-pencil"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </Colxx>
                  <div className="d-flex justify-content-center mb-2">
                    <h4>{contact?.name !== '' ? contact?.name : 'Unknown'}</h4>
                  </div>
                  <Colxx md="12" className="p-0">
                    <Card className="mb-2 p-3" style={{ borderRadius: '20px' }}>
                      <div className="d-flex mb-2">
                        <p className="mb-0 mr-0">
                          <i
                            className={`simple-icon-phone`}
                            style={{
                              marginLeft: '0.2em',
                              marginRight: '0.2em',
                            }}
                          ></i>{' '}
                          Phone{'   '}
                          <b>{contact?.phone}</b>
                        </p>
                      </div>
                      <div className="d-flex mb-2">
                        <p className="mb-0 mr-0">
                          <i className={`iconsminds-at-sign`}></i> Email{'   '}
                          <b>{contact?.email}</b>
                        </p>
                      </div>
                      {/* <div className="d-flex mb-2">
                        <p className="mb-0 mr-0">
                          <i className={`simple-icon-calendar`}></i> Signed Up{' '}
                          {'   '} <b>{contact?.signUp}</b>
                        </p>
                      </div> */}
                      <div className="d-flex mb-2">
                        <p className="mb-0 mr-0">
                          <i className={`iconsminds-calendar-4`}></i> First
                          Activity{'   '} <b>{contact?.firstActivity}</b>
                        </p>
                      </div>
                      <div className="d-flex mb-2">
                        <p className="mb-0 mr-0">
                          <i className={`iconsminds-calendar-4`}></i> Last
                          Activity{'   '}
                          <b>{contact?.lastActivity}</b>
                        </p>
                      </div>
                      <div className="d-flex mb-2">
                        <p className="mb-0 mr-0">
                          <i
                            className={`simple-icon-settings`}
                            style={{
                              marginLeft: '0.2em',
                              marginRight: '0.2em',
                            }}
                          ></i>{' '}
                          Last Channel{'   '}
                          <b>{contact?.lastChannel}</b>
                        </p>
                      </div>
                      {contact?.consent && (
                        <div className="d-flex mb-2">
                          <p className="mb-0 mr-0">
                            <i className="iconsminds-yes"></i> Marketing Consent
                            {'   '}
                            {contact.consent === 'Yes' ? (
                              <b
                                style={{
                                  color: 'green',
                                }}
                              >
                                {contact.consent}
                              </b>
                            ) : (
                              <b style={{ color: 'red' }}>{contact.consent}</b>
                            )}{' '}
                          </p>
                        </div>
                      )}
                      {selectedChat?.visitor && (
                        <Fragment>
                          {selectedChat?.visitor?.location && (
                            <div className="d-flex mb-2">
                              <p className="mb-0 mr-0">
                                <i className={`iconsminds-location-2`}></i>{' '}
                                Location{'   '}
                                <b>{selectedChat?.visitor.location}</b>
                              </p>
                            </div>
                          )}
                          {selectedChat?.visitor?.deviceType && (
                            <div className="d-flex mb-2">
                              <p className="mb-0 mr-0">
                                <i className="iconsminds-computer"></i> Device
                                {'   '}
                                <b>{selectedChat?.visitor.deviceType}</b>
                              </p>
                            </div>
                          )}
                          {selectedChat?.visitor?.browser && (
                            <div className="d-flex mb-2">
                              <p className="mb-0 mr-0">
                                <i className="iconsminds-optimization"></i>{' '}
                                Browser{'   '}
                                <b>{selectedChat?.visitor.browser}</b>
                              </p>
                            </div>
                          )}
                        </Fragment>
                      )}
                    </Card>
                  </Colxx>
                </div>
                {/* </Card> */}
                <Colxx md="12" className="p-0">
                  <Card className="mb-2 p-3" style={{ borderRadius: '20px' }}>
                    <div className="mb-3">
                      <Input
                        type="textarea"
                        onChange={(e) => setNote(e.target.value)}
                        style={{ height: '50px' }}
                        placeholder="Add Note"
                      ></Input>
                    </div>
                    {note !== '' && (
                      <Fragment>
                        <div className="d-flex">
                          <div className="col-md-6 mb-2">
                            <Button
                              color="secondary"
                              className="mr-3"
                              outline
                              size="xs"
                              style={{ width: '100%' }}
                              onClick={() => setNote('')}
                            >
                              Cancel
                            </Button>
                          </div>
                          <div className="col-md-6 mb-2">
                            <Button
                              color="primary"
                              outline
                              size="xs"
                              style={{ width: '100%' }}
                              onClick={handleSaveNotes}
                            >
                              Save
                            </Button>
                          </div>
                        </div>
                      </Fragment>
                    )}
                    <div className="mb-2">
                      <div className="contact-notes-body">
                        <ul className="list-group">
                          {contact?.notes &&
                            contact.notes.length > 0 &&
                            contact.notes.map((m) => (
                              <div className="mt-2 mb-2  details-subheading">
                                <b className="mb-2 d-flex">
                                  {moment(m.date).format(
                                    'MMMM Do YYYY, h:mm:ss a'
                                  )}
                                </b>
                                <p
                                  className="mb-2 d-flex"
                                  style={{ color: 'black' }}
                                >
                                  {m.text}
                                </p>
                              </div>
                            ))}
                        </ul>
                      </div>
                    </div>
                  </Card>
                </Colxx>
              </CardBody>
            </Card>
          </Colxx>
          <Colxx xxs="12" md="9" className="mb-2 col-sm-12 col-md-9 pr-0">
            {integrations.length > 0 ? (
              <ContactDetails
                contactId={contactId}
                contact={contact}
                integrationData={integrations.length > 0 ? integrations : []}
              ></ContactDetails>
            ) : null}
          </Colxx>
        </Row>
      )}
      {editContact === true && (
        <ContactForm
          toggle={toggle}
          visible={editContact}
          item={contact}
          propertyId={propertyId}
          handleSubmit={handleEdit}
        ></ContactForm>
      )}
    </Fragment>
  );
}

const mapStateToProps = ({ chatListApp, settings }) => {
  const { propertyId, timeZone, locale, email } = settings;
  return {
    chatListApp,
    propertyId,
    timeZone,
    locale,
    email,
  };
};
export default connect(mapStateToProps, {})(ContactInfo);
